import { DndContext, closestCenter } from '@dnd-kit/core';
import { arrayMove, SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';
import SortableTile from './SortableTile';
import { useRef } from 'react';
import { fetchWithAuth } from '../../utils/fetchWithAuth'; // załóżmy, że masz taki util

function Tileboard({ tiles, setTiles, editMode }) {
  const saveTimeout = useRef(null);

  const saveOrder = (newTiles) => {
    // Debounce: wyślij do backendu po 2 sekundach od ostatniej zmiany
    if (saveTimeout.current) clearTimeout(saveTimeout.current);
    saveTimeout.current = setTimeout(() => {
      fetchWithAuth(
        `${process.env.REACT_APP_BACKEND_URL}/api/dashboard/update-tile-order/`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tile_ids: newTiles.map(tile => tile.id) }),
        }
      );
    }, 2000);
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = tiles.findIndex(tile => tile.id === active.id);
      const newIndex = tiles.findIndex(tile => tile.id === over.id);
      const newTiles = arrayMove(tiles, oldIndex, newIndex);
      setTiles(newTiles);
      saveOrder(newTiles); // debounced save
    }
  };

  // Użyj editMode do warunkowego włączenia DndContext
  if (!editMode) {
    // Wyświetl kafelki bez możliwości przeciągania
    return (
      <div className="tileboard-area">
        {tiles.map(tile => (
          <SortableTile key={tile.id} tile={tile} disabled />
        ))}
      </div>
    );
  }

  return (
    <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext
        className="tileboard-area"
        items={tiles.map(tile => tile.id)}
        strategy={rectSortingStrategy}
      >
        {tiles.map(tile => (
          <SortableTile key={tile.id} id={tile.id} tile={tile} />
        ))}
      </SortableContext>
    </DndContext>
  );
}

export default Tileboard;